import { CatListItem } from '@blocks-react/components/ListItem';
import { CatHeading } from '@blocks-react/components/Heading';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import { CategoryOrBuyingOption } from '../types';

interface BuyingOptionsType {
  heading?: string;
  list: CategoryOrBuyingOption[];
  isMobile?: boolean;
  isCatCard?: boolean;
  catCardMenuLabel: string;
  ssoLabel: string;
  baseUrl: string;
}

export const BuyingOptions = ({
  heading,
  list,
  isMobile = false,
  isCatCard,
  ssoLabel,
  catCardMenuLabel,
  baseUrl = ''
}: BuyingOptionsType) => {
  return (
    <>
      <CatListItem
        data-track-event={MAIN_NAV_TRACK.EVENT}
        data-track-attr-nltext={'Buying Options'}
        data-track-attr-context={
          MAIN_NAV_TRACK.BUYING_OPTIONS_TOP_SUBMENU_CONTEXT
        }
      >
        <CatHeading
          className="py-0"
          variant="display-sm"
          color={isMobile ? 'knockout' : undefined}
          aria-label={heading}
        >
          {heading}
        </CatHeading>
      </CatListItem>
      <CatListItem
        href={`${baseUrl}${'/self-service-options'}`}
        aria-label={ssoLabel}
        data-track-event={MAIN_NAV_TRACK.EVENT}
        data-track-attr-nltext={'Self-Service Options'}
        data-track-attr-context={
          MAIN_NAV_TRACK.BUYING_OPTIONS_TOP_SUBMENU_CONTEXT
        }
      >
        {ssoLabel}
      </CatListItem>
      {list.map((item: CategoryOrBuyingOption) => {
        return (
          <CatListItem
            href={item?.seoUrlKeyword}
            key={item.name}
            aria-label={item.name}
            data-track-event={MAIN_NAV_TRACK.EVENT}
            data-track-attr-nltext={item?.categoryIdentifier}
            data-track-attr-context={
              MAIN_NAV_TRACK.BUYING_OPTIONS_TOP_SUBMENU_CONTEXT
            }
          >
            {item.name}
          </CatListItem>
        );
      })}
      {isCatCard && (
        <CatListItem
          href={`${baseUrl}${'/catcard'}`}
          aria-label={catCardMenuLabel}
          data-track-event={MAIN_NAV_TRACK.EVENT}
          data-track-attr-nltext={'Cat Card'}
          data-track-attr-context={
            MAIN_NAV_TRACK.BUYING_OPTIONS_TOP_SUBMENU_CONTEXT
          }
        >
          {catCardMenuLabel}
        </CatListItem>
      )}
    </>
  );
};
